// Module
var code = `<div class="alert alert--danger">
  Updates the loan interest accrual and accrual limit of loans by batch.
  This operation is irreversible.
  Please make sure that all the details are correct.
</div>

<h2 class="section-header">Please confirm the following:</h2>
<form name="\$ctrl.form">
  <table class="table">
    <tbody>
    <tr>
      <td>Product numbers</td>
      <td>
        <file-id-upload
          single-file="true"
          ng-model="\$ctrl.parameters.fileId"
          validate-uploaded
          required
          show-remarks="false"
          enable-webcam="false"
          max-files="1"
        ></file-id-upload>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="flex-end">
    <button
      type="button"
      class="btn btn-info"
      ng-click="\$ctrl.downloadSampleFile()">
      Download example
    </button>

    <button
      type="submit"
      class="btn btn-success"
      ng-disabled="\$ctrl.form.\$invalid"
      ng-click="\$ctrl.execute()">
      Execute
    </button>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/batch-edit-loan-accrual/batch-edit-loan-accrual.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;